module.exports = __webpack_public_path__ + "static/media/PDF_123.7d05e5ae.pdf";